import { Spinner } from 'components/Elements';
import { MainLayout } from 'components/Layout';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const { Dashboard } = lazyImport(() => import('features/misc'), 'Dashboard');
const { Profile } = lazyImport(() => import('features/users'), 'Profile');
const { SettingsRoutes } = lazyImport(() => import('features/settings'), 'SettingsRoutes');
const { TeamsRoutes } = lazyImport(() => import('features/teams'), 'TeamsRoutes');
const { ContactInfosRoutes } = lazyImport(
  () => import('features/contactInfo'),
  'ContactInfosRoutes'
);
const { AboutsRoutes } = lazyImport(() => import('features/about'), 'AboutsRoutes');
const { MembersRoutes } = lazyImport(() => import('features/members'), 'MembersRoutes');
const { SocialsRoutes } = lazyImport(() => import('features/socials'), 'SocialsRoutes');
const { FeedbacksRoutes } = lazyImport(() => import('features/feedback'), 'FeedbacksRoutes');
const { PagesRoutes } = lazyImport(() => import('features/pages'), 'PagesRoutes');
const { AccountsRoutes } = lazyImport(() => import('features/users'), 'AccountsRoutes');
const { TransactionsRoutes } = lazyImport(
  () => import('features/transactions'),
  'TransactionsRoutes'
);
const { TenKProjectRoutes } = lazyImport(() => import('features/tenkProject'), 'TenKProjectRoutes');
const { SatelliteCityRoutes } = lazyImport(
  () => import('features/satelliteCity'),
  'SatelliteCityRoutes'
);

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/my-account', element: <Profile /> },
      { path: '/app/accounts/*', element: <AccountsRoutes /> },
      { path: '/app/members/*', element: <MembersRoutes /> },
      { path: '/app/transactions/*', element: <TransactionsRoutes /> },
      { path: '/app/teams/*', element: <TeamsRoutes /> },
      { path: '/app/10k-project/*', element: <TenKProjectRoutes /> },
      { path: '/app/settings/*', element: <SettingsRoutes /> },
      { path: '/app/contact-info/*', element: <ContactInfosRoutes /> },
      { path: '/app/about/*', element: <AboutsRoutes /> },
      { path: '/app/feedback/*', element: <FeedbacksRoutes /> },
      { path: '/app/satellite-city/*', element: <SatelliteCityRoutes /> },
      { path: '/app/pages/*', element: <PagesRoutes /> },
      { path: '/app/socials/*', element: <SocialsRoutes /> },
      { path: '/app/', element: <Dashboard /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
